export const PRODUCTOS = 'PRODUCTOS'
export const ADDPRODUCTO = (PRODUCTOS) =>{
    return{
        type:ADDPRODUCTO,
        payload:PRODUCTOS
    }
}
